// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"column-layout"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3L3 21H10L10 3L3 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M14 3L14 21H21L21 3L14 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M3 3L3 21H10L10 3L3 3Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M14 3L14 21H21V3L14 3Z","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-column-layout')
export default class ColumnLayoutIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'column-layout',
    }
  }
}
